export const initialState = (currentLinksIds) => ({
  selectedLinks: [...currentLinksIds],
});

export const types = {
  SET_SELECTED_LINKS: 'SET_SELECTED_LINKS',
};

export const reducer = (state, { type, payload }) => {
  const { selectedLinks } = state;
  switch (type) {
    case types.SET_SELECTED_LINKS:
      return {
        selectedLinks:
          selectedLinks.indexOf(payload) === -1
            ? [...selectedLinks, payload]
            : selectedLinks.filter((link) => link !== payload),
      };
    default:
      throw new Error();
  }
};
